import {IRestFilter} from '../rest/types';
import {IFilter} from '../store/filter/types';

export const getSavedFilterFromRest = (
    filterRest: IRestFilter
): IFilter => {
    const filter = {...filterRest};
    return filter;
};
